import { render, staticRenderFns } from "./queue_user_management.vue?vue&type=template&id=2b6c5884"
import script from "./queue_user_management.vue?vue&type=script&lang=js"
export * from "./queue_user_management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports